import { isSameMonth, parseISO } from "date-fns";

import { useCaptainBillingUsage } from "../api/useCaptainBillingUsage";
import { CAPTAIN_USAGE_MONTHS } from "../constants";
import type { CaptainBillingAccount } from "../types";

export function useTopUpSpent(account: Pick<CaptainBillingAccount, "clientId" | "month">) {
  const { data, isLoading, isError } = useCaptainBillingUsage(account.clientId, CAPTAIN_USAGE_MONTHS);
  const spent = data?.find((month) => isSameMonth(parseISO(month.month), parseISO(account.month)))?.usedFromTopUpTokens ?? 0;
  return { spent, isLoading, isError };
}
